const segmentRules = [
  {
    name: 'At least one of... (nested or)',
    key: 'or',
    type: 'or',
    conditions: [],
    availableFilters: {},
    rules: [],
  },
  {
    name: 'Price increase',
    key: 'priceIncrease',
    type: 'event',
    conditions: [{ field: 'action', conditionType: 'term', values: ['priceIncrease'] }],
    availableFilters: {
      price: {},
      discount: {},
      discountPercent: {},
    },
  },
  {
    name: 'Price decrease',
    key: 'priceDecrease',
    type: 'event',
    conditions: [{ field: 'action', conditionType: 'term', values: ['priceDecrease'] }],
    availableFilters: {
      price: {},
      discount: {},
      discountPercent: {},
    },
  },
  {
    name: 'Became in stock',
    key: 'inStock',
    type: 'event',
    conditions: [{ field: 'action', conditionType: 'term', values: ['inStock'] }],
    availableFilters: {},
  },
  {
    name: 'Became out of stock',
    key: 'outOfStock',
    type: 'event',
    conditions: [{ field: 'action', conditionType: 'term', values: ['outOfStock'] }],
    availableFilters: {},
  },
  {
    name: 'Product attributes',
    key: 'priceIncrease',
    type: 'product',
    availableFilters: {
      categories: {},
      price: {},
      discount: {},
      discountPercent: {},
    },
  },
];

export default segmentRules;
